import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {}

  clean() {
    window.history.replaceState({}, "", window.location.pathname);
  }
}
